module.exports = __webpack_public_path__ + "media/images/the-home-depot-logo-png-transparent-f7147e2a3a3b437c62f273190ee4070a.png";